import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'

import { itemPath } from '../../../utility/coachCertification'

import classes from './ItemsRail.module.scss'

const itemIcon = (item) => {
  if (item.done) { return 'fa fa-check-circle' }
  if (!item.available) { return 'fa fa-lock' }
  if (item.type === 'quiz') { return item.final ? 'fa fa-graduation-cap' : 'fa fa-flag' }

  return item.lesson.vimeoEmbedUrl ? 'fa fa-play-circle' : 'fa fa-file-text-o'
}

const ItemsRailItem = ({ item, title, meta, active }) => {
  const navigate = useNavigate()
  const ref = useRef(null)
  const isOpen = item.available || item.done

  useEffect(() => {
    if (!active || !ref.current) { return }

    let list = ref.current.parentElement
    while (list && getComputedStyle(list).overflowY !== 'auto') { list = list.parentElement }
    if (list) { list.scrollTop = ref.current.offsetTop - list.offsetTop - (list.clientHeight - ref.current.offsetHeight) / 2 }
  }, [active])

  return (
    <button
      ref={ref}
      type='button'
      className={classNames('d-flex align-items-start text-left', classes.item, { [classes.itemActive]: active })}
      onClick={() => navigate(itemPath(item))}
      disabled={!isOpen}
    >
      <i
        className={classNames(itemIcon(item), classes.itemIcon, {
          [classes.itemIconDone]: item.done, [classes.itemIconActive]: active && !item.done,
        })}
        aria-hidden='true'
      />
      <span className='min-w-0'>
        <span className={classNames(classes.itemTitle, { [classes.itemTitleActive]: active, [classes.itemTitleLocked]: !isOpen })}>{title}</span>
        <span className={classes.itemMeta}>{meta}</span>
      </span>
    </button>
  )
}

ItemsRailItem.propTypes = {
  item: PropTypes.shape({
    type: PropTypes.string.isRequired,
    final: PropTypes.bool,
    available: PropTypes.bool.isRequired,
    done: PropTypes.bool.isRequired,
    lesson: PropTypes.shape({ vimeoEmbedUrl: PropTypes.string }),
  }).isRequired,
  title: PropTypes.string.isRequired,
  meta: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
}

export default ItemsRailItem
